<ng-template #pageOperationsModal>
    <div class="page-modal-section client-operation-modal">
        <div class="page-modal-heading-section">
            <span>{{ page_operation_type }} Prospect Details</span>
            <span class="page-modal-close-icon" (click)="closeClientOperationModal()">&times;</span>
        </div>
        <div class="progress-section">
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 0 }">1</div>
                <p class="each-step-label">Personal & Contact Info</p>
            </div>
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 1 }">2</div>
                <p class="each-step-label">Household & Behaviour Info</p>
            </div>
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 2 }">3</div>
                <p class="each-step-label">Other & Additional Info</p>
            </div>
        </div>
        <div class="page-modal-content-section">

            <ng-container *ngIf="page_operation_stepper == 1">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Personal Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Data Source *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.source_type_id" (selectionChange)="getDataTypeValues(page_data.source_type_id)">
                            <mat-option [value]="''">Select Data Source</mat-option>
                            <mat-option *ngFor="let data_type of data_type_list" [value]="data_type.id">{{ data_type.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.source_type_id">Data Source is Required.</p>
                    </div>

                    <div class="page-modal-input-section client-modal-input-section" *ngIf="page_data.source_type_id != 2 && data_type_values_list.length > 0 && page_data.source_type_id != 4">
                        <p class="page-modal-input-label">Provider *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.source_id">
                            <mat-option [value]="''">Select Provider</mat-option>
                            <mat-option *ngFor="let data_type_value of data_type_values_list" [value]="data_type_value.id">{{ data_type_value.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.source_id">Provider is Required.</p>
                    </div>

                    <div class="page-modal-input-section client-modal-input-section" *ngIf="page_data.source_type_id == 2">
                        <p class="page-modal-input-label">Referrer *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.source" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.source">Referrer is Required.</p>
                    </div>

                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Prospect ID *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.prospect_id" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.prospect_id">Prospect ID is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">First Name *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.first_name" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.first_name">First Name is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Last Name *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.last_name" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.last_name">Last Name is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Mobile Number {{APP_CONSTANTS.PHONE_NUMBER_FORMAT}}</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.telephone_number" maxlength="{{APP_CONSTANTS.PHONE_NUMBER_LENGTH}}" appFormatPhoneNumber />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.telephone_number">Mobile Number is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Email *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.email" [disabled]="page_operation_type != 'Add'" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.email">Email should be valid.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Gender</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.gender_id">
                            <mat-option [value]="''">Select Gender</mat-option>
                            <mat-option *ngFor="let gender of genders_list" [value]="gender.id">{{ gender.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.gender_id">Gender is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Date of Birth *</p>
                        <input
                            type="text"
                            class="page-modal-input"
                            bsDatepicker
                            [maxDate]="current_date"
                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                             placement="right"
                            [(ngModel)]="page_data.birth_date"
                        />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.birth_date">Date of Birth is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Education</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.education">
                            <mat-option [value]="''">Select Education</mat-option>
                            <mat-option [value]="'School'">School</mat-option>
                            <mat-option [value]="'UnderGraduate'">UnderGraduate</mat-option>
                            <mat-option [value]="'PostGraduate'">PostGraduate</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.education">Education is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Occupation</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.occupation">
                            <mat-option [value]="''">Select Occupation</mat-option>
                            <mat-option [value]="'Business Owner'">Business Owner</mat-option>
                            <mat-option [value]="'retired'">Retired</mat-option>
                            <mat-option [value]="'self-employed'">Self Employed</mat-option>
                            <mat-option [value]="'employed'">Employed</mat-option>
                            <mat-option [value]="'student'">Student</mat-option>
                            <mat-option [value]="'unemployed'">Unemployed</mat-option>
                            <mat-option [value]="'unknown'">Unknown</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.occupation">Occupation is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Experience(Years)</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.years_experience" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.years_experience">Experience(Years) is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Marital Status</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.marital_status">
                            <mat-option [value]="''">Select Marital Status</mat-option>
                            <mat-option [value]="'Married'">Married</mat-option>
                            <mat-option [value]="'Single'">Single</mat-option>
                            <mat-option [value]="'Inferred Married'">Inferred Married</mat-option>
                            <mat-option [value]="'Inferred Single'">Inferred Single</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.marital_status">Marital Status is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Individual Income({{APP_CONSTANTS.CURRENCY_SYMBOL}}) *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.individual_income_in_dollars_actual" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.individual_income_in_dollars_actual">Individual Income({{APP_CONSTANTS.CURRENCY_SYMBOL}}) is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Status</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.status_id">
                            <mat-option [value]="''">Select Status</mat-option>
                            <mat-option *ngFor="let status of status_list" [value]="status.id">{{ status.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.status_id">Status is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Primary Address Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.zip_code">ZIP Code is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Residence Type</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.homeowner_or_renter">
                            <mat-option [value]="''">Select Residence Type</mat-option>
                            <mat-option [value]="'HomeOwner'">HomeOwner</mat-option>
                            <mat-option [value]="'Renter'">Renter</mat-option>
                            <mat-option [value]="'Office Address'">Office Address</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.homeowner_or_renter">Residence Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Years in Residence</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.years_in_residence" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.years_in_residence">Years in Residence is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Address 2 Information (Optional)</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_2_state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_2_region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_zip_code">ZIP Code is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Residence Type</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_2_homeowner_or_renter">
                            <mat-option [value]="''">Select Residence Type</mat-option>
                            <mat-option [value]="'HomeOwner'">HomeOwner</mat-option>
                            <mat-option [value]="'Renter'">Renter</mat-option>
                            <mat-option [value]="'Office Address'">Office Address</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_homeowner_or_renter">Residence Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Years in Residence</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_years_in_residence" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_years_in_residence">Years in Residence is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Address 3 Information (Optional)</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_3_state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_3_region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_zip_code">ZIP Code is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Residence Type</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_3_homeowner_or_renter">
                            <mat-option [value]="''">Select Residence Type</mat-option>
                            <mat-option [value]="'HomeOwner'">HomeOwner</mat-option>
                            <mat-option [value]="'Renter'">Renter</mat-option>
                            <mat-option [value]="'Office Address'">Office Address</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_homeowner_or_renter">Residence Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Years in Residence</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_years_in_residence" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_years_in_residence">Years in Residence is Required.</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="page_operation_stepper == 2">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Household Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Is Primary Contact</p>
                        <mat-radio-group [(ngModel)]="page_data.is_primary_contact" (change)="changePrimaryContact()">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <!-- <p class="page-modal-input-error" *ngIf="page_data_errors.is_primary_contact">Is Primary Contact is Required.</p> -->
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">
                            <span>Household ID</span>
                            <span class="look-up-link" (click)="lookUpHouseHold()" *ngIf="page_data.is_primary_contact == false">Look up Household</span>
                        </p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.household_id" [disabled]="true" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.household_id">Household ID is Required.</p>
                    </div>
                    <ng-container *ngIf="page_data.is_primary_contact == true">
                        <div class="page-modal-input-section client-modal-input-section">
                            <p class="page-modal-input-label">Adults in Household</p>
                            <input type="text" class="page-modal-input" [(ngModel)]="page_data.adults_in_household" (keypress)="numberOnly($event)" />
                            <p class="page-modal-input-error" *ngIf="page_data_errors.adults_in_household">Adults in Household is Required.</p>
                        </div>
                        <div class="page-modal-input-section client-modal-input-section">
                            <p class="page-modal-input-label">Children in Household</p>
                            <input type="text" class="page-modal-input" [(ngModel)]="page_data.children_in_household" (keypress)="numberOnly($event)" />
                            <p class="page-modal-input-error" *ngIf="page_data_errors.children_in_household">Children in Household is Required.</p>
                        </div>
                        <div class="page-modal-input-section client-modal-input-section">
                            <p class="page-modal-input-label">Household Income({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                            <input type="text" class="page-modal-input" [(ngModel)]="page_data.household_income_in_dollars_actual" (keypress)="numberOnly($event)" />
                            <p class="page-modal-input-error" *ngIf="page_data_errors.household_income_in_dollars_actual">Experience(Years) is Required.</p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="page_data.is_primary_contact == false">
                        <div class="page-modal-input-section client-modal-input-section" *ngIf="this.page_data.household_id != '' && this.page_data.household_id != null">
                            <p class="page-modal-input-label">Primary Contact Name</p>
                            <input type="text" class="page-modal-input" [(ngModel)]="page_data.household_primary_contact_name" [disabled]="true" />
                        </div>
                    </ng-container>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Behaviour Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Real Estate Investor</p>
                        <mat-radio-group [(ngModel)]="page_data.real_estate_investor">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <!-- <p class="page-modal-input-error" *ngIf="page_data_errors.real_estate_investor">Real Estate Investor is Required.</p> -->
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Premium Credit Card Holder</p>
                        <mat-radio-group [(ngModel)]="page_data.premium_credit_card_holder">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <!-- <p class="page-modal-input-error" *ngIf="page_data_errors.premium_credit_card_holder">Premium Credit Card Holder is Required.</p> -->
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Heavy Transactor</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.heavy_transactor">
                            <mat-option [value]="''">Select Heavy Transactor</mat-option>
                            <mat-option [value]="'Least Likely Heavy Transactor'">Least Likely Heavy Transactor</mat-option>
                            <mat-option [value]="'Average Heavy Transactor'">Average Heavy Transactor</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.heavy_transactor">Heavy Transactor is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Economic Stability</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.economic_stability">
                            <mat-option [value]="''">Select Economic Stability</mat-option>
                            <mat-option [value]="'Well Likely Economically Stable'">Well Likely Economically Stable</mat-option>
                            <mat-option [value]="'Medium Likely Economically Stable'">Medium Likely Economically Stable</mat-option>
                            <mat-option [value]="'Less Likely Economically Stable'">Less Likely Economically Stable</mat-option>
                            <mat-option [value]="'Lesser Likely Economically Stable'">Lesser Likely Economically Stable
                            </mat-option>
                            <mat-option [value]="'Least Likely Economically Stable'">Least Likely Economically Stable</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.economic_stability">Economic Stability is Required.</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="page_operation_stepper == 3">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Other Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Vehicle Type</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.vehicle_type" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.vehicle_type">Vehicle Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Vehicle Count</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.vehicle_count" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.vehicle_count">Vehicle Count is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Property Type</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.property_type" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.property_type">Property Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Home Equity available for Mortgage({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.home_equity_available_for_mortgage_in_dollars_actual" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.home_equity_available_for_mortgage_in_dollars_actual">Home Equity available for Mortgage({{APP_CONSTANTS.CURRENCY_SYMBOL}}) is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Loan to Value in Percentage</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.loan_to_value_in_percentage">
                            <mat-option [value]="''">Select Loan to Value in Percentage</mat-option>
                            <mat-option [value]="'NO Loans'">NO Loans</mat-option>
                            <mat-option [value]="'01 to 49'">01 to 49</mat-option>
                            <mat-option [value]="'50 to 59'">50 to 59</mat-option>
                            <mat-option [value]="'60 to 69'">60 to 69</mat-option>
                            <mat-option [value]="'70 to 74'">70 to 74</mat-option>
                            <mat-option [value]="'75 to 79'">75 to 79</mat-option>
                            <mat-option [value]="'80 to 84'">80 to 84</mat-option>
                            <mat-option [value]="'85 to 89'">85 to 89</mat-option>
                            <mat-option [value]="'90 to 94'">90 to 94</mat-option>
                            <mat-option [value]="'95 to 99'">95 to 99</mat-option>
                            <mat-option [value]="'100 to 999'">100 to 999</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.loan_to_value_in_percentage">Loan to Value in Percentage is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Market Value of Home({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.market_value_of_home_in_dollars_actual" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.market_value_of_home_in_dollars_actual">Market Value of Home({{APP_CONSTANTS.CURRENCY_SYMBOL}}) is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Liquid Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.net_worth_actual" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.net_worth_actual">Liquid Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}) is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Total Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.total_networth_actual" (keypress)="numberOnly($event)" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.total_networth_actual">Total Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}) is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Additional Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section" *ngIf="page_operation_type != 'Add'">
                        <p class="page-modal-input-label">AI Segment</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.segment" [disbled]="true" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.segment">AI Segment is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Last Date of Contact</p>
                        <input
                            type="text"
                            class="page-modal-input"
                            bsDatepicker
                            [maxDate]="current_date"
                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                             placement="left"
                            [(ngModel)]="page_data.last_date_of_contact"
                        />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.last_date_of_contact">Last Date of Contact is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Business Plan</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.business_plan_id">
                            <mat-option [value]="''">Select Business Plan</mat-option>
                            <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id">{{ business_plan.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.business_plan_id">Business Plan is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Social Networking Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Linkedin</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.linkedin_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.linkedin_url">Linkedin is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Twitter</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.twitter_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.twitter_url">Twitter is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Facebook</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.facebook_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.facebook_url">Facebook is Required.</p>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="navigateBack()" *ngIf="page_operation_stepper > 1">Back</button>
            <button class="page-modal-primary-button" (click)="validateClientDetails()" *ngIf="page_operation_stepper < 3">Continue</button>
            <button class="page-modal-primary-button" (click)="validateClientDetails()" *ngIf="page_operation_stepper == 3">Save</button>
            <span class="page-modal-input-error" *ngIf="global_error">Please fill the mandatory fields</span>

        </div>
    </div>
</ng-template>

<ng-template #householdLookupModal>
    <div class="page-modal-section household-modal">
        <div class="page-modal-heading-section">
            <span>Lookup Household Information</span>
            <span class="page-modal-close-icon" (click)="closeHouseholdLookupModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Search by Name or Household ID</p>
                <input type="text" class="page-modal-input" [(ngModel)]="household_search_key" (input)="searchHousehold()" />
            </div>
            <div class="page-modal-input-section" *ngIf="household_list.length > 0">
                <table class="page-inner-table">
                    <thead>
                        <tr>
                            <th>Primary Contact Name</th>
                            <th>Household ID</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let household_client of household_list">
                            <td>{{household_client.household_primary_contact_name}}</td>
                            <td>{{household_client.household_id}}</td>
                            <td>
                                <button class="copy-button" (click)="copy(household_client)">Copy</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="page-modal-input-section" *ngIf="household_search_key != '' && household_list.length == 0">
                <p class="page-modal-delete-description">No Data</p>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeHouseholdLookupModal()">Cancel</button>
          </div>
    </div>
</ng-template>
